import type {
	Tenant,
	TenantDetail,
	TenantListResponse,
	CreateTenantPayload,
} from '../types/iam-tenant.types';
import type { CursorParams } from '../types/api.types';
import { api } from './client';

/**
 * Query key factory for tenants
 */
export const tenantKeys = {
	all: ['tenants'] as const,
	lists: () => [...tenantKeys.all, 'list'] as const,
	list: (params?: Record<string, unknown>) => [...tenantKeys.lists(), params] as const,
	details: () => [...tenantKeys.all, 'detail'] as const,
	detail: (id: string) => [...tenantKeys.details(), id] as const,
};

/**
 * Fetch paginated list of tenants
 */
export async function getTenants(params?: CursorParams): Promise<TenantListResponse> {
	const response = await api.get<TenantListResponse>('/v1/tenant', { params });
	return response.data;
}

/**
 * Fetch a single tenant by ID
 */
export async function getTenant(id: string): Promise<TenantDetail> {
	const response = await api.get<TenantDetail>(`/v1/tenant/${id}`);
	return response.data;
}

/**
 * Create a new tenant
 */
export async function createTenant(payload: CreateTenantPayload): Promise<Tenant> {
	const response = await api.post<Tenant>('/v1/tenant', payload);
	return response.data;
}
